// General dependencies
import _ from '@centerhealth/common/lodash';

// Local dependencies
import { IConfig } from './interfaces';
import { devConfig } from './config/development';
import { stagingConfig } from './config/staging';
import { prodConfig } from './config/production';
import { defaultConfig } from './config/default';
import { svelteConfig } from './config/env.config';

export * from './interfaces';

export const getConfig = (): IConfig => {
  let config: IConfig | null = null;
  const basicConfig = _.merge(defaultConfig, svelteConfig);
  switch (defaultConfig.env) {
    case 'production':
      config = _.merge(basicConfig, prodConfig);
      break;
    case 'staging':
      config = _.merge(basicConfig, stagingConfig);
      break;
    default:
      config = _.merge(basicConfig, devConfig);
      break;
  }
  return config;
};

export const config: IConfig = getConfig();
export default config;

export * from './services';
